import React, { useEffect, useState } from 'react';
import { Container } from 'components/styles/Common.styled';
import RemoteConfiguration from 'remoteConfiguration/remoteConfiguration';
import Route from 'enum/route.enum';
import { useNavigate } from 'react-router-dom';
import EventBus from 'utils/eventBus';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

const ProxyLoading = () => {
  let [subscribe] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const verifyDevice = () => {
      RemoteConfiguration.verifyDeviceAndInitialize().then(
        (res) => {
          const channelOnly = Storages.MainStorage.getItem(StorageKeys.Keys.CHANNELONLY);
          navigate(channelOnly ? Route.route.CHANNEL : Route.route.LANDING);
        },
        (err) => {}
      );
    };
    subscribe['server_restored'] = EventBus.subscribe('server_restored', () => {
      verifyDevice();
    });

    verifyDevice();

    return () => {
      for (const key in subscribe) {
        subscribe[key]['unsubscribe']();
      }
    };
  }, []);

  return (
    <>
      <Container style={{ direction: 'ltr' }}>
        <div className='notification'>
          <div className='columns'>
            <div className='column is-6 is-offset-6'>
              <div className='loader-wrapper'>
                <div className='loader is-loading' style={{ height: 80, width: 80 }}></div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ProxyLoading;
